import { render, staticRenderFns } from "./AddFactor.vue?vue&type=template&id=7fae62ba"
import script from "./AddFactor.vue?vue&type=script&lang=js"
export * from "./AddFactor.vue?vue&type=script&lang=js"
import style0 from "./AddFactor.vue?vue&type=style&index=0&id=7fae62ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports